module.exports = __webpack_public_path__ + "static/media/marketoHero.b44d0ccb.png";